import React, { useState, useEffect } from 'react';
import { TextField, Button, Paper, Typography, MenuItem, Select, InputLabel, FormControl, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createUser, updateUser } from '../../redux/actions/user/userAction';
import { toast } from 'react-toastify';

const UserForm = ({ selectedUser, onReset }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    username: '',
    password:'',
    role:'',
    status: 'Active',
  });

  useEffect(() => {
    if (selectedUser) {
      setFormData(selectedUser);
    } else {
      setFormData({ username: '', password:'', role:'', status: 'Active' });
    }
  }, [selectedUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedUser) {
        await dispatch(updateUser(selectedUser.id, formData));
        toast.success('User updated successfully');
      } else {
        await dispatch(createUser(formData));
        toast.success('User created successfully');
      }
      setFormData({ username: '', password:'', role:'', status: 'Active' });
      if (onReset) onReset();
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while processing user';
      toast.error(errorMessage);
    }
  };

  const handleClear = () => {
    setFormData({ username: '', password:'', role:'', status: 'Active' });
    if (onReset) onReset();
  };

  return (
    <Paper elevation={3} sx={{ p: 3, boxShadow: 'none', background: 'transparent'  }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
        {selectedUser ? 'Edit User' : 'Add User'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Username"
          name="username"
          value={formData.username}
          onChange={handleChange}
          margin="normal"
          required
          autoComplete="off"
        />
        <TextField
          fullWidth
          label="Password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          margin="normal"
          required
          autoComplete="off"
        />
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Role</InputLabel>
          <Select
            name="role"
            value={formData.role}
            label="Role"
            onChange={handleChange}
          >
            <MenuItem value="Admin">Admin</MenuItem>
            <MenuItem value="User">User</MenuItem>
            <MenuItem value="Reports">Reports</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Status</InputLabel>
          <Select
            name="status"
            value={formData.status}
            label="Status"
            onChange={handleChange}
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {selectedUser ? 'Update' : 'Add'}
          </Button>
          <Button 
            type="button" 
            variant="outlined" 
            color="primary" 
            fullWidth
            onClick={handleClear}
          >
            Clear
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default UserForm;
